import { createContext, useContext } from 'react';
import type { IntakePortalSessionForUser } from '@/models/types';

export interface CurrentSessionContextValue {
  currentSessionId: number | null;
  currentSession: IntakePortalSessionForUser | undefined;
  sessions: IntakePortalSessionForUser[];
  isLoading: boolean;
  selectSession: (sessionId: number) => void;
}

export const CurrentSessionContext = createContext<CurrentSessionContextValue | null>(null);

export const useCurrentSession = (): CurrentSessionContextValue => {
  const context = useContext(CurrentSessionContext);

  if (!context) {
    throw new Error('useCurrentSession must be used within a CurrentSessionProvider');
  }

  return context;
};
